module.exports = __webpack_public_path__ + "static/media/lg-white-pine-pond-2.bb4bbbf2.jpg";